import dlugosc from '../inputs/dlugosc'
import szerokosc from '../inputs/szerokosc'
import colors, { colorNames } from '@constants/values/colors'

const nadwoziePrzyczepa = { t: 'Nadwozie', inputs: [
    dlugosc,
    szerokosc,
    { t: 'Kolor', type: 'multi-checkbox', name: 'kolor', options: colors, names: colorNames },
]}

export default nadwoziePrzyczepa